<form #currentForm="ngForm" novalidate>
  <div class="form-group">
    <label>Matter Date Type</label>
    <select required class="form-control" #matter_date_type_id="ngModel" name="matter_date_type_id" [(ngModel)]="matter_date.matter_date_type_id">
      <option *ngFor="let matter_date_type of form_options.matter_date_types" [value]="matter_date_type.id">{{ matter_date_type.name }}</option>
    </select>
    <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(matter_date_type_id)">Matter date type needs to be selected</div>
  </div>
  <div class="form-group">
    <label>Date</label>
    <input type="text" class="form-control" required #date_of="ngModel" name="date_of" [(ngModel)]="matter_date.date_of" placeholder="Click to select date" [appDatepicker]="" (dateSelected)="matter_date.date_of = $event" />
    <div class="alert alert-danger alert-padding-sm" [hidden]="!fieldShowErrorMessage(date_of)">Matter date needs to be selected</div>
  </div>
  <div class="form-group text-center">
    <button type="button" [disabled]="formSubmitting" class="btn btn-sm btn-primary" (click)="saveMatterDate(currentForm.form.valid)">Save</button>
    &nbsp;
    <button type="button" [disabled]="formSubmitting" class="btn btn-sm btn-secondary" (click)="cancelForm()">Cancel</button>
  </div>
</form>
